
export default {
    name: "VideoPlaceholder",
    components: {
        ProgressCircular: () => import("@/components/base/ProgressCircular"),
    },
    props: {
        animated: {
            type: Boolean,
            default: true,
        },
        titleOnly: {
            type: Boolean,
            default: false,
        },
    },
}
